<template>
  <div class="container instructions">
    <p>Now it's time to try it yourself. Respond at your own pace to the pictures for each turn by pressing your arrow buttons: </p>

    <ul>
      <li>
        <strong>Left</strong> arrow for the first picture, then
      </li>
      <li>
        <strong>Up</strong> arrow if the second picture completes the correct sequence, or
      </li>
      <li>
        <strong>Right</strong> arrow if the second picture does not complete the correct sequence
      </li>
    </ul>

    <div class="row">
      <div class="list-line col-md-8">

        <div class="alert alert-success practiceCompleteText" role="alert" v-if="tenPracticeRounds">
          <h4 class="alert-heading">Practice round complete!</h4>
          <button
          type="button"
          name="endInstructions"
          class="btn btn-success btn-start"
          v-if="tenPracticeRounds"
          @click="start()"
          >Next</button>
        </div>
        <!--span class="feedbackArrowUp" v-if="showFeedbackArrowUp">&#8593;</span>
        <b-alert class="feedbackText" v-if="showFeedback" show> 
          <p>{{feedbackText}}</p>
        </b-alert-->
        <b-alert class="customAlert" v-if="showRedo" show>
          <p>It looks like you're working hard to learn this task. Remember, press the:</p>
          <ul>
          <li>Left arrow button for the first picture, then </li>
          <li>Up arrow button if the second picture completes the correct sequence, or</li>
          <li>Right arrow button if the second picture does not complete the correct sequence.</li> 
          <li>We'll do a little more practice so you can meet the accuracy goal.</li>
          </ul>
          
          <button
            type="button"
            name="previousInstructions"
            class="btn btn-secondary"
            @click="showRedo = false"
          >Ok</button>
        </b-alert>
        <transition-group v-else-if="!tenPracticeRounds" name="list" class="list" tag="ul">
          <li
            v-for="(item, index) in reversedItems"
            :key="item"
            class="item"
            :style="place(index)"
            style="display: flex;"
          >

            <div
              v-if="['cue'].includes(states[item % states.length])"
              class="col-sm align-self-center"
            >
              <img :src="getImage(item % states.length)" class="training-leftbox" />
            </div>

            <div
              v-if="['probe'].includes(states[item % states.length])"
              class="col-sm align-self-center"
            >
              <img :src="getImage(item % states.length)" class="training-rightbox" />
            </div>

            <div
              v-else-if="states[item % states.length] === 'fixation'"
              class="col-sm align-self-center"
            >
              <div class="training-fixation">+</div>
            </div>
            <div
              v-else-if="states[item % states.length] === 'outcome'"
              class="col-sm align-self-center"
            >
              <p v-if="display === 'Correct'" :class="{ trainingSuccess: display === 'Correct', trainingFailure: display === 'Incorrect' }">
                <center> +1 point </center>
              </p>
              <p v-else :class="{ trainingSuccess: display === 'Correct', trainingFailure: display === 'Incorrect' }">
                <center> +0 point </center>
              </p>
            </div>
          </li>
        </transition-group>
      </div>
      <div class="col-md-4">
        <div :class="{ 'gray': counter % this.states.length === 0 }">
          <strong>Cue</strong>: The first picture
        </div>
        <div :class="{ 'gray': counter % this.states.length === 1 }">
          <strong>Probe</strong>: The second picture
        </div>
        <div :class="{ 'gray': counter % this.states.length === 2 }">
          <strong>Outcome</strong>: The result of your responses for the sequence
        </div>
        <br />
        <div>
          Accuracy:
          <br />
          {{ accuracy_all }}% out of {{ counter_all }} All Pictures
          <br />
          {{ accuracy_bx }}% out of {{ counter_bx }} BX Pictures
        </div>
        <br/>
        <p>When the green "Next" button appears, that means your training is accurate enough to proceed to the task.</p>
        <br/>
        <!-- div class="alert alert-success" role="alert" v-if="tenPracticeRounds">
          <h4 class="alert-heading">Practice round complete!</h4>
        </div -->
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <button
          type="button"
          name="previousInstructions"
          class="btn btn-secondary"
          @click="previous()"
        >Previous</button>
        <!-- button
          type="button"
          name="endInstructions"
          class="btn btn-success btn-start"
          v-if="tenPracticeRounds"
          @click="start()"
        >Next</button -->
      </div>
    </div>
  </div>



</template>

<script>
import { mapGetters, mapActions  } from 'vuex'
import * as Mousetrap from 'mousetrap'
export default {
  data: () => {
    return {
      states: ['cue', 'probe', 'outcome'], // list the order of the states
      items: [0], // starts the slide at the first state
      counter: 0, // counters number of slides
      counter_all: 0, // counts each round
      counter_bx: 0, // counts each round of BX
      correct_all: 0, // accuracy for All
      correct_bx: 0, // accuracy for BX
      outcome: 'Incorrect', // holds the value to determine the display
      display: 'Incorrect', // displays the outcome
      pattern: ['A', 'X'],
      pattern_list: [
        ['A', 'X'],
        ['B', 'X'],
        ['A', 'X'],
        ['A', 'Y'],
        ['A', 'X'],
        ['B', 'Y']
      ],
      tenPracticeRounds: false,
      timer: undefined, // used for timing
      restartAt: 21, 
      routeToEndAt: 3,
      counter_reroute: 0,
      showRedo: false,
      feedbackText: '',
      showFeedback: false,
      showFeedbackArrowUp: false,
      feedbackIntroCount: 0
    }
  },
  computed: {
    ...mapGetters(['getACue', 'getXProbe', 'getBCue', 'getYProbe']),
    reversedItems () {
      return this.items.slice().reverse()
    },
    accuracy_all () {
      if (this.counter_all === 0) {
        return 0
      } else {
        return ((this.correct_all * 100) / this.counter_all).toPrecision(4)
      }
    },
    accuracy_bx () {
      if (this.counter_bx === 0) {
        return 0
      } else {
        return ((this.correct_bx * 100) / this.counter_bx).toPrecision(4)
      }
    }
  },
  watch: {
    counter_all: function (rounds_completed) {
      // Keeps next button hidden until after completing 10 rounds
      if (rounds_completed === 10 && this.accuracy_all > 65 && this.accuracy_bx > 65) {
        this.tenPracticeRounds = true
        this.showFeedback = false
        this.showFeedbackArrowUp = false
        Mousetrap.unbind(['left', 'right', 'up','1','2','3'])
      }
    }
  },
  methods: {
    ...mapActions(['untimed_training_response']),
    place (index) {
      // position of the images
      return {
        right: `calc(50% - 100px + ${Math.log(index + 1) * 290}px)`,
        bottom: `calc(50% - 100px + ${Math.log(index + 1) * 75}px)`,
        zIndex: `${this.items.length - index}`
      }
    },
    routeToEnd(){
      this.$router.replace('/complete/failed_training')
    },
    reDo(){
      this.items = [0] // starts the slide at the first state
      this.counter = 0 // counters number of slides
      this.counter_all = 0 // counts each round
      this.counter_bx = 0 // counts each round of BX
      this.correct_all = 0 // accuracy for All
      this.correct_bx = 0 // accuracy for BX
      this.outcome = 'Incorrect' // holds the value to determine the display
      this.display = 'Incorrect' // displays the outcome
      this.showRedo = true
      this.counter_reroute++
      this.feedbackText = ''
      this.showFeedback = false
      this.showFeedbackArrowUp = false,
      this.feedbackIntroCount = 0

    },
    giveFeedBack(theTrial, theKeypress, theStage){
      if(theKeypress == null){
        this.feedbackText = 'For the first picture, press LEFT. Remember it is probably correct.'
        this.showFeedback = true
        this.feedbackIntroCount++
        return
      }
      if(theStage == 'outcome'){
            // this.feedbackText = ''  
            // this.showFeedback = false        
            // this.showFeedbackArrowUp = false
            return
      }
      
      let trialStr = theTrial[0] + theTrial[1]
      if(this.feedbackIntroCount == 1){
        this.feedbackText = 'The second picture is correct; so the whole sequence is correct. Press UP.'  
        this.showFeedback = true
        this.feedbackIntroCount++
        return
      }else if(this.feedbackIntroCount == 2){
        this.feedbackText = 'For the first picture, press LEFT. Remember it is definitely incorrect.'  
        this.showFeedback = true
        this.feedbackIntroCount++
        return
      }else if(this.feedbackIntroCount == 3){
        this.feedbackText = 'The second picture looks correct, but the first picture was incorrect, so the sequence is incorrect. Press RIGHT.'
        this.showFeedback = true
        this.feedbackIntroCount++
        return 
      }
      // theKeypress === 37 left
      // theKeypress === 38 up
      // theKeypress === 39 right
      if(trialStr == 'AX'){
        /*
        AX trials
          A cue
            (Ppt presses left) Good job!
            (Ppt presses other) For the first picture, always press LEFT.
          X probe
            (Ppt presses up) Good job! The whole sequence is correct.
            (Ppt presses other) You should press UP. Both pictures were correct, so the whole sequence is correct.
        */ 
        this.showFeedback = true
        this.showFeedbackArrowUp = true
        if(theStage == 'cue'){
          if(theKeypress == 37){
            this.feedbackText = 'Good!'  
          }else{
            this.feedbackText = 'For the first picture, always press LEFT.'  
          }
        }else if(theStage == 'probe'){
          if(theKeypress == 38){
            this.feedbackText = 'Good! The whole sequence was correct.'  
         }else{
            this.feedbackText = 'You should press UP. The whole sequence was correct.'  
          }
        }
      }else if(trialStr == 'AY'){
        /*
        AY trials
          A cue
            (Ppt presses left) Good job!
            (Ppt presses other) For the first picture, always press LEFT.
          Y probe
            (Ppt presses right) Good job! Since the second picture is incorrect, the whole sequence is incorrect. 
            (Ppt presses other) You should press RIGHT.  Since the second picture is incorrect, the whole sequence is incorrect.
        */ 
        this.showFeedback = true
        this.showFeedbackArrowUp = true
        if(theStage == 'cue'){
          if(theKeypress == 37){
            this.feedbackText = 'Good!'  
          }else{
            this.feedbackText = 'For the first picture, always press LEFT.'  
          }
        }else if(theStage == 'probe'){
          if(theKeypress == 39){
            this.feedbackText = 'Good! Since the second picture was incorrect, the whole sequence was incorrect.'  
          }else{
            this.feedbackText = 'You should press RIGHT.  Since the second picture was incorrect, the whole sequence was incorrect.'  
          }
        }
      }else if(trialStr == 'BX'){
        /*
        BX trials
          B cue
            (Ppt presses left) Good job!
            (Ppt presses other) For the first picture, always press LEFT.
          X probe
            (Ppt presses right) Good job! Since the first picture was incorrect, the whole sequence is incorrect. 
            (Ppt presses other) You should press RIGHT.  Since the first picture was incorrect, the whole sequence is incorrect.
        */
        this.showFeedback = true
        this.showFeedbackArrowUp = true
        if(theStage == 'cue'){
          if(theKeypress == 37){
            this.feedbackText = 'Good!'  
          }else{
            this.feedbackText = 'For the first picture, always press LEFT.'  
          }
        }else if(theStage == 'probe'){
          if(theKeypress == 39){
            this.feedbackText = 'Good! Since the first picture was incorrect, the whole sequence is incorrect.'  
          }else{
            this.feedbackText = 'You should press RIGHT.  Since the first picture was incorrect, the whole sequence was incorrect.'  
          }
        }      
      }else if(trialStr == 'BY'){
        /*
        BY trials
          B cue
            (Ppt presses left) Good job!
            (Ppt presses other) For the first picture, always press LEFT.
         Y probe
            (Ppt presses right) Good job! Since both pictures were incorrect, the whole sequence is incorrect.
            (Ppt presses other) You should press RIGHT. Since both pictures were incorrect, the whole sequence is incorrect.
        */ 
        this.showFeedback = true
        this.showFeedbackArrowUp = true
        if(theStage == 'cue'){
          if(theKeypress == 37){
            this.feedbackText = 'Good!'  
          }else{
            this.feedbackText = 'For the first picture, always press LEFT.'  
          }
        }else if(theStage == 'probe'){
          if(theKeypress == 39){
            this.feedbackText = 'Good! The whole sequence was incorrect.'  
          }else{
            this.feedbackText = 'You should press RIGHT. Since both pictures were incorrect, the whole sequence was incorrect.'  
          }
        }
      }else{
        console.log("should not be here")
      }
    },
    nextStage () {
        if((this.counter_all === this.restartAt)&& (this.states[this.counter % this.states.length] === 'outcome')){
          if(this.counter_reroute === this.routeToEndAt){
            this.routeToEnd()
          }else{
            this.reDo()
          }
        }else{
          // next state
          // update counter and text
          this.counter++
          this.items.push(this.counter)
          if (this.items.length >= this.states.length * 3) {
            this.items.shift()
          }

          if (this.states[this.counter % this.states.length] === 'cue') {
            this.setPattern()
          } else if (this.states[this.counter % this.states.length] === 'outcome') {
            this.display = this.outcome
            this.outcomeTimer()
          }
        }
    },
    getImage (i) {
      // get the the image based off of the state's position
      const image = this.states[i]
      if (image === 'cue') {
        if (this.pattern[0] === 'A') {
          return this.getACue
        } else {
          return this.getBCue
        }
      } else {
        if (this.pattern[1] === 'X') {
          return this.getXProbe
        } else {
          return this.getYProbe
        }
      }
    },
    setPattern () {
      this.pattern = this.pattern_list[this.counter_all % 6]
    },
    start () {
      // this.$router.replace('/blank_page/trial')
      this.$router.replace('/instructions/6')
    },
    previous () {
      this.$router.replace('/instructions/33')
    },
    outcomeTimer () {
      this.timer = setTimeout(() => {
        this.nextStage()
      }, 1000)
    }
  },
  mounted () {
    /*
    this.feedbackText = 'For the first picture, press LEFT. Remember it is probably correct.'
    this.showFeedback = true
    this.feedbackIntroCount++
    */
    this.giveFeedBack(undefined, undefined, undefined)
    Mousetrap.bind(['left', 'right', 'up','1','2','3'], e => {
    
      // clearTimeout(this.timer)
      const key = parseInt(e.keyCode, 10)

      /*
      if(this.feedbackIntroCount == 1){
        this.feedbackText = 'The second picture is correct; so the whole sequence is correct. Press UP.'  
        this.showFeedback = true
        this.feedbackIntroCount++
      }else if(this.feedbackIntroCount == 2){
        this.feedbackText = 'For the first picture, press LEFT. Remember it is definitely incorrect.'  
        this.showFeedback = true
        this.feedbackIntroCount++
      }else if(this.feedbackIntroCount == 3){
        this.feedbackText = 'The second picture looks correct, but the first picture was incorrect, so the sequence is incorrect. Press RIGHT.'
        this.showFeedback = true
        this.feedbackIntroCount++
      }else{
//        this.feedbackText = ''
//        this.showFeedback = false  
        this.giveFeedBack(this.pattern, key, this.states[this.counter % this.states.length])
      }
  */

      this.giveFeedBack(this.pattern, key, this.states[this.counter % this.states.length])


      // key === 37 left
      // key === 38 up
      // key === 39 right
      if (this.states[this.counter % this.states.length] === 'cue') {
        if (key === 37 || key === 49) {
          // left
          this.outcome = 'Correct'
        } else {
          this.outcome = 'Incorrect'
        }
        this.untimed_training_response({r: key, counter_all: this.counter_all, correct_all: this.correct_all, correct_bx: this.correct_bx, response_state: "cue", outcome: this.outcome})
        this.nextStage()
      } else if (this.states[this.counter % this.states.length] === 'probe') {
        if (key === 39 || key === 51) {
          // right
          if (this.outcome === 'Incorrect') {
            // Do nothing
          } else if (this.pattern[0] === 'A' && this.pattern[1] === 'X') {
            // Press right for target pattern
            this.outcome = 'Incorrect'
          } else {
            // press right for non-target pattern
            this.outcome = 'Correct'
          }
        } else if (key === 38 || key === 50) {
          // up
          if (this.outcome === 'Incorrect') {
            // Do nothing if already incorrect
          } else if (this.pattern[0] === 'A' && this.pattern[1] === 'X') {
            // Press up for target pattern
            this.outcome = 'Correct'
          } else {
            // press left for non-target pattern
            this.outcome = 'Incorrect'
          }
        } else {
          this.outcome = 'Incorrect'
        }

        if (this.pattern[0] === 'B' && this.pattern[1] === 'X') {
          this.counter_bx++
        }
        this.counter_all++

        if (
          this.outcome === 'Correct' &&
          this.pattern[0] === 'B' &&
          this.pattern[1] === 'X'
        ) {
          this.correct_bx++
          this.correct_all++
        } else if (this.outcome === 'Correct') {
          this.correct_all++
        }
        this.untimed_training_response({r: key, counter_all: this.counter_all, correct_all: this.correct_all, correct_bx: this.correct_bx, response_state: "probe", outcome: this.outcome})
        this.nextStage()
      } else if (this.states[this.counter % this.states.length] === 'outcome') {
        // do nothing
        // this.untimed_training_response({r: key, counter_all: this.counter_all, correct_all: this.correct_all, correct_bx: this.correct_bx, response_state: "outcome", outcome: this.outcome})
      } else {
        this.nextStage()
      }
    })
  },
  beforeDestroy () {
    Mousetrap.unbind(['left', 'right', 'up','1','2','3'])
    clearTimeout(this.timer)
  }
}
</script>

<!-- add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list-line {
  height: 50vh;
  overflow: hidden;
  border: 1px solid;
  background-color: #333;
}
.list {
  list-style: none;
}
.list-move {
  transition: transform 0.5s;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.item {
  border: 1px solid;
  border-radius: 10px;
  background-color: white;
  position: absolute;
  height: 200px;
  width: 200px;
}
.training-image {
  display: block;
  margin: auto;
  width: 40%;
}
.training-leftbox {
  display: block;
  margin: auto;
  width: 40%;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-100%, -50%);
}
.training-rightbox {
  display: block;
  margin: auto;
  width: 40%;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-0%, -50%);
}
.training-fixation {
  text-align: center;
  margin: auto;
  font-size: 6em;
}
.trainingSuccess {
  color: green;
  text-align: center;
  font-size: 25px;
}
.trainingFailure {
  color: red;
  text-align: center;
  font-size: 25px;
}
.gray {
  background-color: #ccc;
  border-radius: 5px;
  padding-left: 0.5em;
}
.instructions {
  font-size: 24px;
}
.btn-start {
  margin-top: 2px;
  float: right;
}
.customAlert{
  position: absolute;
  top: 17%;
  left: 5px;
  right: 5px;
  font-size: 20px;
}
.feedbackText{
  font-size: 20px;
  position: absolute;
  bottom: 12px;
  left: 5px;
  right: 5px;
  width: 80%; 
  margin: auto;
  height: 20%;
  /* border: 3px solid #8AC007; */
}
.feedbackArrowUp {
  position: absolute;
  color: white;
  font-size: 65px;
  bottom: 18%;
  left: 18%;
}
.practiceCompleteText{
  font-size: 20px;
  position: absolute;
  top: 35%;
  left: 5px;
  right: 5px;
  width: 80%; 
  margin: auto;
  height: 25%;
  /* border: 3px solid #8AC007; */
}

</style>
